<div class="header-left" (click)="router.navigate(['/dashboard'])" style="cursor: pointer">
  <div class="header-left__logo">
    <img alt="Freely Logo" class="header-left__logo-img1" src="/assets/logos/freely-logo-white.svg" style="width: 200px; height: auto; margin-top: 20px;">
    <img alt="Freely Accept Logo" class="header-left__logo-img2" src="/assets/accept-white.png">
    @if (nonProdEnv()) {
      <span class="header-left__env" style="position: absolute; left: 84px; bottom: 0; height: 22px; line-height: 22px; font-style: italic; color: #fff; white-space: nowrap;">{{ nonProdEnv() }}</span>
    }
  </div>
</div>
<div class="header-middle">
  <nav class="header-nav">
    <div class="header-nav-item dropdown" [class.dropdown--active-section]="isDashboardSection()"
         (mouseenter)="hoveredSection.set('dashboard')" (mouseleave)="hoveredSection.set(null)">
      <a (click)="navigateTo('/dashboard', $event)"
         class="dropdown-toggle"
         [class.router-link-active]="isDashboardSection()"
         [attr.aria-current]="isDashboardSection() ? 'page' : null">
        Dashboard
      </a>
      @if (showDashboardSubnav()) {
        <!-- Horizontal sub-nav, aligned under the parent, current page highlighted -->
        <div class="subnav">
          <a class="subnav__link" (click)="navigateTo('/dashboard/payments', $event)"
             [attr.aria-current]="isCurrentRoute('/dashboard/payments') ? 'page' : null">Payments</a>
          @if (dashboardAvailable('ar')) {
            <a class="subnav__link" (click)="navigateTo('/dashboard/ar', $event)"
               [attr.aria-current]="isCurrentRoute('/dashboard/ar') ? 'page' : null">AR</a>
          }
          @if (dashboardAvailable('ledger')) {
            <a class="subnav__link" (click)="navigateTo('/dashboard/ledger', $event)"
               [attr.aria-current]="isCurrentRoute('/dashboard/ledger') ? 'page' : null">Ledger</a>
          }
          @if (dashboardAvailable('erp')) {
            <a class="subnav__link" (click)="navigateTo('/dashboard/erp', $event)"
               [attr.aria-current]="isCurrentRoute('/dashboard/erp') ? 'page' : null">ERP</a>
          }
          @if (dashboardAvailable('ach')) {
            <a class="subnav__link" (click)="navigateTo('/dashboard/ach', $event)"
               [attr.aria-current]="isCurrentRoute('/dashboard/ach') ? 'page' : null">ACH</a>
          }
          @if (dashboardAvailable('credit-card')) {
            <a class="subnav__link" (click)="navigateTo('/dashboard/credit-card', $event)"
               [attr.aria-current]="isCurrentRoute('/dashboard/credit-card') ? 'page' : null">CC</a>
          }
          @if (dashboardAvailable('schedule-payments')) {
            <a class="subnav__link" (click)="navigateTo('/dashboard/schedule-payments', $event)"
               [attr.aria-current]="isCurrentRoute('/dashboard/schedule-payments') ? 'page' : null">Schedule Payments</a>
          }
        </div>
      }
    </div>
       @if(this.activeProfile?.profileDetail?.profileType=="DISTRIBUTOR") {
    <div class="header-nav-item dropdown" [class.dropdown--active-section]="isHistorySection()"
         (mouseenter)="hoveredSection.set('history')" (mouseleave)="hoveredSection.set(null)"
         *hasPermission="['GET_TRANSACTIONS', 'GET_BATCH']">
      <a (click)="navigateTo('/history', $event)"
         class="dropdown-toggle"
         [class.router-link-active]="isHistorySection()"
         [attr.aria-current]="isHistorySection() ? 'page' : null">
        History
      </a>
      @if (showHistorySubnav()) {
        <!-- Horizontal sub-nav, aligned under the parent, current page highlighted -->
        <div class="subnav">
          <a class="subnav__link" (click)="navigateTo('/history/payments', $event)"
             *hasPermission="'GET_TRANSACTIONS'"
             [attr.aria-current]="isCurrentRoute('/history/payments') ? 'page' : null">Payments</a>
          <a class="subnav__link" (click)="navigateTo('/history', $event)"
             *hasPermission="['GET_TRANSACTIONS', 'GET_BATCH']"
             [attr.aria-current]="isCurrentRoute('/history') || isCurrentRoute('/history/transactions') ? 'page' : null">Transactions</a>
          <a class="subnav__link" (click)="navigateTo('/history/requests', $event)"
             *hasPermission="'REQUEST_VIEW'"
             [attr.aria-current]="isCurrentRoute('/history/requests') || isCurrentRoute('/requests') ? 'page' : null">Requests</a>
        </div>
      }
    </div>
  
    <a routerLink="/customers" 
       *hasPermission="'GET_CUSTOMERS'"
       routerLinkActive="router-link-active"
       [attr.aria-current]="isCurrentRoute('/customers') ? 'page' : null">Customers</a>
       }
    <a routerLink="/reports"
       *hasPermission="'GET_REPORTS'"
       routerLinkActive="router-link-active"
       [attr.aria-current]="isCurrentRoute('/reports') ? 'page' : null">Reports</a>
    @if (canViewBilling()) {
      <a routerLink="/billing"
         routerLinkActive="router-link-active"
         [attr.aria-current]="isCurrentRoute('/billing') ? 'page' : null">Billing</a>
    }
    @if (isSystemAdmin() && isSystemProfile()) {
      <a (click)="navigateTo('/system-admin', $event)"
         [class.router-link-active]="isCurrentRoute('/system-admin')"
         [attr.aria-current]="isCurrentRoute('/system-admin') ? 'page' : null">Admin Dashboard</a>
    }
  </nav>
</div>
<div class="header-right">
  @if (this.activeProfile?.profileDetail?.profileType=="DISTRIBUTOR") {
    @if (quickPayEnabled()) {
      <button *hasPermission="'TRANSACTION_SALE'" mat-stroked-button class="quick-pay-btn" routerLink="/payment/quick-pay">quick pay</button>
    }
    <button *hasPermission="'TRANSACTION_SALE'" mat-raised-button class="collect-payment-btn" routerLink="/payment/collect">collect payment</button>
  }

  <!-- Positioning context for the notification bell, which overlays the avatar's
       top-right corner. The bell is a sibling rather than a child because the
       avatar is itself a <button> — nesting one button inside another is invalid
       markup, and the bell's click would bubble up and open the profile menu. -->
  <div class="header-avatar">
    <button
      class="admin-menu__button"
      (click)="isOpen = !isOpen" type="button" cdkOverlayOrigin #trigger="cdkOverlayOrigin"
    ><app-avatar size="medium" [profileId]="activeProfile?.profileDetail?.profileId" /></button>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayPositions]="[{
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top'
    }]"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
  >
    <div class="admin-menu">
      <button class="admin-menu__close" (click)="isOpen = false">
        <mat-icon fontSet="fa" fontIcon="fa-xmark" />
      </button>
      <div class="admin-menu__top">
        <app-avatar size="large" [profileId]="activeProfile?.profileDetail?.profileId" />
        <div class="admin-menu__info">
          <div class="admin-menu__info-name">
            <h5>{{ userName() }}</h5>
            <h4>{{ activeProfile?.profileDetail?.companyName }}</h4>
            {{ activeProfile?.profileDetail?.companyCity }}, {{ activeProfile?.profileDetail?.companyState }}
          </div>
          <button *hasPermission="['ADMIN_GET_PROFILE', 'ADMIN_GET_USER', 'ADMIN_EDIT_USER', 'ADMIN_CREATE_USER']" 
                  mat-raised-button color="primary"
                  routerLink="/administration"
                  (click)="isOpen = false"
          >Administration</button>
        </div>
      </div>
      <div class="admin-menu__middle">
        <ul class="admin-menu__items">
          @for (profile of profiles; track profile.profileDetail.profileId) {
          <li
            class="admin-menu__item" (click)="selectProfile(profile);isOpen = false"
            [class.active]="profile.profileDetail.profileId == activeProfile?.profileDetail?.profileId"
          >
            <div class="admin-menu__item-wrapper">
              <div class="admin-menu__item-media">
                <app-avatar size="small" [profileId]="profile.profileDetail.profileId" alt="Profile Avatar" />
              </div>
              <div class="admin-menu__item-name">
                {{ profile.profileDetail.profileName }}<br>
                {{ profile.profileDetail.companyCity }}, {{ profile.profileDetail.companyState }}
              </div>
            </div>
          </li>
          }
        </ul>
      </div>
      <div class="admin-menu__bottom">
        <div class="admin-menu__actions">
          <button mat-raised-button mat-stroked-button
                  routerLink="/administration/user-access"
                  (click)="isOpen = false">Add Account</button>
          <button *hasPermission="'AGENT_DESKTOP_LOGIN'"
                  mat-raised-button mat-stroked-button type="button"
                  (click)="startDesktopAgent()">Start Desktop Agent</button>
          <button mat-raised-button mat-stroked-button type="button" (click)="logout()">Sign Out</button>
        </div>
      </div>
    </div>
  </ng-template>

    <!-- Gated on NOTIFICATION_VIEW: without it the inbox endpoints 403 and the
         bell would show a permanent zero. -->
    <app-notification-bell *hasPermission="'NOTIFICATION_VIEW'" />
  </div>
</div>